<template>
  <div
    :class="[
      'text-secondary-900 text-sm font-semibold',
      props.format.includes('image')
        ? 'my-2'
        : 'flex items-center text-center px-1 h-full',
    ]">
    <span
      v-if="props.title"
      v-tooltip.top="{
        value:
          props.format.includes('image') && props.title.length > 18
            ? props.title
            : null,
        class: `!z-[1300] ${!rtl ? 'text-left' : 'text-right'}`,
      }"
      :class="[
        props.format.includes('image') && props.title.length > 18
          ? 'truncatedTitle'
          : '',
        !props.format.includes('image') ? 'break-all' : '',
      ]">
      {{ displayTitle }}
    </span>

    <span v-else class="font-normal text-red-600">
      {{ t('blocksSettings.pairing.empty_text') }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { PairingItemFormat } from '@amit/types';
import { computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  format: {
    type: String as PropType<PairingItemFormat>,
    default: PairingItemFormat.TextImage,
  },
  title: {
    type: String,
    default: '',
  },
  rtl: {
    type: Boolean,
    default: true,
  },
});

const truncatedTitle = computed(() =>
  props.title.length > 18 ? props.title.slice(0, 15) + '...' : props.title,
);

const displayTitle = computed(() =>
  props.format.includes('image') && props.title.length > 18
    ? truncatedTitle.value
    : props.title,
);
</script>
